import merge from 'lodash/merge.js';

import Alert from './Alert.js';
import Collection from './Collection.js';

export default merge(Collection('Alerts', Alert), {
    state: {},

    getters: {},

    actions: {
        /**
         * @param context
         * @param item
         * @returns {Promise<any>}
         */
        add(context, item) {
            return new Promise(resolve => {
                const { key } = item;

                if (context.getters.has(key)) {
                    context.dispatch('remove', key);
                }

                item.store_key = key;

                context.commit('ADD', item);

                context.dispatch(`${key}/hydrate`, item).then(() => resolve());
            });
        },
    },

    mutations: {},
});
